import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { KeyRound } from 'lucide-react';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [resetToken, setResetToken] = useState('');
  const { requestPasswordReset } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await requestPasswordReset(email);
      setSuccess(true);
      // In development, show the token
      if (response.reset_token) {
        setResetToken(response.reset_token);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container" data-testid="forgot-password-page">
      <div className="auth-card">
        <div className="auth-header">
          <KeyRound className="auth-icon" size={32} />
          <h2 className="auth-title">Reset Password</h2>
          <p className="auth-subtitle">Enter your email to receive a reset link</p>
        </div>
        
        {success ? (
          <div className="auth-success" data-testid="reset-success">
            <p>If an account exists with that email, a reset link has been sent.</p>
            {resetToken && (
              <div className="dev-token-display">
                <p><strong>Development Mode:</strong></p>
                <p>Your reset token is: <code>{resetToken}</code></p>
                <Link to={`/reset-password/${resetToken}`} className="auth-link">
                  Click here to reset your password
                </Link>
              </div>
            )}
          </div>
        ) : (
          <>
            {error && <div className="auth-error" data-testid="reset-error">{error}</div>}
            <form onSubmit={handleSubmit} className="auth-form">
              <div className="auth-form-group">
                <label htmlFor="email" className="auth-label">Email</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="auth-input"
                  data-testid="email-input"
                  placeholder="you@agency.com"
                  required
                />
              </div>
              <button 
                type="submit" 
                disabled={loading}
                className="auth-button"
                data-testid="reset-button"
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          </>
        )}
        
        <p className="auth-link-text">
          Remember your password? <Link to="/login" className="auth-link">Login here</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
